import DivisionPage from "@/components/DivisionPage";
import { DIVISIONS } from "@/data/content";

const Infrastructure = () => <DivisionPage division={DIVISIONS.infra} />;

export default Infrastructure;
